export default {
  items: [
    {
      name: 'Dashboard',
      url: '/corporate/eventtags/dashboard',
      icon: 'icon-speedometer',
    },
    {
      name: 'Manage Organizer',
      url: '/corporate/eventtags/eventorganizer', // ok 1
      icon: 'icon-people',
    },
    {
      name: 'Events',
      icon: 'icon-star',
      children: [
        {
          name: 'Manage Events',
          url: '/corporate/eventtags/events',
          icon: 'icon-star',
        },
        {
          name: 'Sub Event Feedbacks',
          url: '/corporate/eventtags/subeventfeedbacks',
          icon: 'icon-star',
        },
        {
          name: 'Speaker Feedbacks',
          url: '/corporate/eventtags/speakerfeedbacks',
          icon: 'icon-star',
        }
      ]
    },
    // {
    //   name: 'Manage Speakers',
    //   url: '/eventtags/publicspeaker',
    //   icon: 'icon-people',
    // },
    {
      name: 'Review Participants',
      icon: 'icon-people',
      children: [
        {
          name: 'Check IN',
          url: '/corporate/eventtags/event-checkin',
          icon: 'icon-star',
        },
        {
          name: 'View All Checked IN Participants',
          url: '/corporate/eventtags/all-event-checked-participants',
          icon: 'icon-star',
        },
        {
          name: 'Question Bank',
          url: '/corporate/eventtags/event-question-bank',
          icon: 'icon-star',
        }
      ]
    },
    {
      name: 'Notifications',
      icon: 'icon-bell',
      children: [
        {
          name: 'Send Event Notification',
          url: '/corporate/eventtags/notifications/create', // ok 1
          icon: 'icon-bell',
        },
        {
          name: 'View Notifications',
          url: '/corporate/eventtags/notifications/view', // ok 1
          icon: 'icon-bell',
        }
      ]
    },
    {
      name: 'Reports',
      icon: 'icon-chart',
      children: [
        {
          name: 'Insights',
          url: '/corporate/eventtags/insights',
          icon: 'icon-chart',
        },
      ]
    }
  ]
};
